export default __webpack_public_path__ + "ebb1168abe3cc6e8206568b3c39a9a6b.png";